module.exports = __webpack_public_path__ + "img/add-square-alternate.92a63205.svg";